/**
 * @file
 * A pressable header view toggle.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { iconButton, onClick } = berTags.dom;
  const { announce } = berTags.util;

  // Header view toggle: a pressable pill switching a grouping on and off.
  components.viewToggle = ({ key, label, icon: iconName, value, onChange }) => {
    const toggle = iconButton(
      'ber-tags__sort-option ber-tags__view-toggle',
      label,
      iconName,
    );
    toggle.dataset.toggle = key;
    let on = !!value;
    const sync = () => {
      toggle.classList.toggle('is-active', on);
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
    };
    onClick(toggle, (event) => {
      event.stopPropagation();
      on = !on;
      sync();
      onChange(on);
      announce(`${label}, ${on ? Drupal.t('on') : Drupal.t('off')}`);
    });
    sync();
    return { el: toggle, current: () => on };
  };
})(Drupal);
